<script>
import PhotoUploader from '@components/uploaders/photo-uploader.vue';
import { counterMixin } from '@mixins/counter-mixin';
import { workoutModelMixin } from '@mixins/models/workout-model-mixin';
import { cleverTapMixin } from '@mixins/cleverTap-mixin';
import { mask } from 'vue-the-mask';
import {
  adminPanelMethods,
  adminPanelComputed,
  authComputed,
  exerciseDifficultyComputed,
  mediaComputed,
  mediaMethods,
  modalMethods,
  muscleGroupComputed,
  workoutComputed,
  workoutMethods,
} from '@state/helpers';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';

export default {
  components: {
    PhotoUploader,
  },
  directives: { mask },
  props: {
    content: {
      type: Object,
      required: false,
      default: null,
    },
  },
  mixins: [counterMixin, workoutModelMixin, cleverTapMixin],
  data() {
    return {
      workoutObj: {},
      formErr: null,
      selectedLevel: null,
      selectedMuscleGroups: [],
      initWorkoutObj: {},
      hasChanges: false,
      saving: false,
    };
  },
  computed: {
    ...authComputed,
    ...exerciseDifficultyComputed,
    ...mediaComputed,
    ...muscleGroupComputed,
    ...workoutComputed,
    ...adminPanelComputed,
  },
  created() {
    this.workoutObj = this.getWorkoutModel();
    this.initWorkoutObj = cloneDeep(this.getWorkoutModel());
  },
  mounted() {},
  methods: {
    ...adminPanelMethods,
    ...mediaMethods,
    ...modalMethods,
    ...workoutMethods,
    isFormValid() {
      if (!Object.keys(this.workoutObj).length) {
        this.formErr = {};
        this.formErr.titleErr = this.workoutObj.label
          ? null
          : 'Title is required';
        this.formErr.descErr = this.workoutObj.description
          ? null
          : 'Description is required';
        return false;
      } else {
        this.formErr = null;
        return true;
      }
    },
    clearForm() {
      this.workoutObj = this.getWorkoutModel();
      this.selectedMuscleGroups = [];
      this.selectedLevel = null;
      this.formErr = null;
      this.clearMedia();
    },
    onSelectMuscleGroup(value) {
      if (this.selectedMuscleGroups && this.selectedMuscleGroups.length) {
        const matchesMuscleGroup = this.selectedMuscleGroups.find((group) => {
          if (group._id === value._id || group.muscleGroup_id === value._id) {
            return group;
          }
        });

        if (matchesMuscleGroup) {
          const i = this.selectedMuscleGroups.findIndex(
            (group) =>
              group._id === value._id || group.muscleGroup_id === value._id
          );
          const groups = this.selectedMuscleGroups.splice(i, 1);
          this.workoutObj.muscleGroups = groups;
        } else {
          this.selectedMuscleGroups.push({
            muscleGroup_id: value._id,
            label: value.label,
          });
          this.workoutObj.muscleGroups.push({
            muscleGroup_id: value._id,
            label: value.label,
          });
        }
      } else {
        this.selectedMuscleGroups.push({
          muscleGroup_id: value._id,
          label: value.label,
        });
        this.workoutObj.muscleGroups.push({
          muscleGroup_id: value._id,
          label: value.label,
        });
      }
    },
    isSelectedMuscleGroup(id) {
      if (this.selectedMuscleGroups && this.selectedMuscleGroups.length) {
        const matchesMuscleGroup = this.selectedMuscleGroups.find((group) => {
          if (group._id === id || group.muscleGroup_id === id) {
            return group;
          }
        });

        if (matchesMuscleGroup) {
          return true;
        }
      }
    },
    onSelectLevel(value) {
      this.selectedLevel = value.label;
      this.workoutObj.exerciseDifficulty = {
        exerciseDifficulty_id: value._id,
        label: value.label,
      };
    },
    assignMediaUrls() {
      console.log('Setting New Media');
      console.log(this.hasNewMedia('cover', 'workouts'));
      const defaultWorkoutImageUrl = `https://org-${this.userOrgId}.s3.amazonaws.com/default-workout.jpg`;
      this.workoutObj.mediaAssets = {
        coverPhoto: {
          url: this.hasNewMedia('cover', 'workouts')
            ? this.hasNewMedia('cover', 'workouts').publicUrl
            : defaultWorkoutImageUrl,
        },
        coverVideo: {
          url: this.hasNewMedia('video', 'workouts')
            ? this.hasNewMedia('video', 'workouts').publicUrl
            : null,
          thumbnail: this.uploadedThumbnailVideoUrl,
        },
        thumbnailPhoto: {
          url: this.uploadedThumbnailImageUrl
            ? this.uploadedThumbnailImageUrl
            : defaultWorkoutImageUrl,
        },
      };
    },
    async buildWorkoutPayload() {
      await this.assignMediaUrls();
      return this.workoutObj;
    },
    async save() {
      this.initWorkoutObj = this.workoutObj;
      this.hasChanges = false;
      if (this.isFormValid()) {
        const payload = await this.buildWorkoutPayload();
        this.saving = true;

        this.createWorkout({
          workoutObj: {
            ...payload,
            org_id: this.userOrgId,
            trainer_id: this.trainerId || payload.trainer_id,
            timeToComplete: payload.timeToComplete
              ? this.$_covertToSeconds(payload.timeToComplete + ':00')
              : 0,
          },
        })
          .then((res) => {
            this.saving = false;
            if (res.success) {
              this.setHideAdminPanel();
              this.clearForm();
              this.setHasChanges(false);

              if (
                this.currentUser &&
                this.currentUser.roles &&
                this.currentUser.roles.isTrainer &&
                res &&
                res.programWorkout
              ) {
                const workout = res.programWorkout._id;
                const trainer = this.trainerEmail;
                this.$_pushCleverTapEvent('Create Library Workout', {
                  workout,
                  trainer,
                });
              }
            }
          })
          .catch((e) => console.log(e));
      }
    },
  },
  watch: {
    workoutObj: {
      handler(newVal, oldVal) {
        if (newVal && oldVal) {
          this.hasChanges = !isEqual(this.initWorkoutObj, this.workoutObj);
          this.setHasChanges(this.hasChanges);
        }
      },
      deep: true,
    },
    isAdminPanelActive(val) {
      this.hasChanges = false;
      if (!val) {
        this.clearForm();
      }
    },
  },
};
</script>

<template>
  <form @submit.prevent="save">
    <div class="row">
      <div class="col">
        <label for="title">Title</label>
        <BaseInputText
          :class="[{ 'input-error': formErr && formErr.titleErr }]"
          v-model="workoutObj.label"
          name="title"
          placeholder="ex: Full Body Conditioning Workout"
          :error="formErr && formErr.titleErr"
        />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label for="muscle_group">Muscle Groups</label>
        <v-select
          multiple
          class="tdm-multi-select"
          :closeOnSelect="false"
          :options="allMuscleGroups"
          :searchable="false"
          :clearable="false"
          :value="selectedMuscleGroups"
        >
          <template v-slot:selected-option-container="{ option }">
            <div v-if="selectedMuscleGroups && selectedMuscleGroups.length > 1">
              {{ selectedMuscleGroups.length }} Selected
            </div>
            <div v-else>{{ option.label }}</div>
          </template>
          <template v-slot:option="{ _id, label }">
            <div
              class="option-label-wrapper"
              @click="onSelectMuscleGroup({ _id, label })"
            >
              <div>{{ label }}</div>
              <BaseIcon
                class="icon-check"
                name="check"
                v-if="isSelectedMuscleGroup(_id)"
              />
            </div>
          </template>
        </v-select>
      </div>

      <div class="col">
        <label for="level">Level</label>
        <v-select
          :options="allExerciseDifficulties"
          :searchable="false"
          :clearable="false"
          :value="selectedLevel"
          @input="onSelectLevel"
        />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label for="description">Description</label>
        <BaseInputTextarea
          :class="[{ 'input-error': formErr && formErr.titleErr }]"
          v-model="workoutObj.description"
          name="description"
          placeholder="ex: Getting your strongest core in 3 workouts"
          :error="formErr && formErr.descErr"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <label for="title">Time to Complete</label>
        <BaseInputText
          :class="[{ 'input-error': formErr && formErr.titleErr }]"
          type="tel"
          name="completion_time"
          label="min"
          v-model="workoutObj.timeToComplete"
          v-mask="[`##`]"
          placeholder="mm"
          :error="formErr && formErr.titleErr"
        />
      </div>
      <div class="col">&nbsp;</div>
    </div>

    <div class="row">
      <div class="col">
        <PhotoUploader
          requestType="workouts"
          type="cover"
          helper-text="Photos must be .jpg, .jpeg, .gif, or .webp, no larger than 4MB. Square
          images work best."
        />
      </div>
    </div>

    <!-- TODO: Leverage PanelFooter slots (/footer/panel-footer.vue) -->
    <div :class="['panel-footer', { 'form-error': formErr }]">
      <BaseButton
        type="button"
        class="btn-primary btn-clear"
        @click="clearForm"
      >
        <BaseIcon name="times" />
        Cancel
      </BaseButton>
      <span class="divider-vertical">&nbsp;</span>
      <BaseButton
        type="button"
        class="btn-primary btn-clear"
        @click="save"
        :disabled="!hasChanges && !hasNewMedia('cover', 'workouts')"
        :style="{
          opacity:
            (!hasChanges && !hasNewMedia('cover', 'workouts')) || saving
              ? 0.6
              : 1,
        }"
      >
        <BaseIcon v-if="saving" name="sync" spin />
        <BaseIcon v-if="!saving" name="save" />
        Save
      </BaseButton>
    </div>
  </form>
</template>

<style lang="scss" scoped>
@import '@design';

.col-4 {
  label {
    white-space: nowrap;
  }
}

.panel-footer {
  align-items: center;
  background-color: $color-header-bg;
  border-radius: $size-input-border-radius;
  bottom: 1rem;
  display: flex;
  justify-content: flex-end;
  padding: 1rem 2rem;
  position: fixed;
  width: 94%;
  z-index: 9999;

  &.form-error {
    background-color: $color-error-dark;
  }

  .divider-vertical {
    border-left: 1px solid white;
    height: 2.5rem;
  }

  .btn-primary {
    &:active {
      background: rgba($color-white-wo-rgb, 0.1);
      color: white;
    }

    &:focus {
      background: transparent;
      color: white;
    }

    &:not(:disabled):not(.disabled) {
      &:active {
        background: rgba($color-white-wo-rgb, 0.1);
        color: white;
      }

      &:focus {
        background: transparent;
        color: white;
      }
    }
  }

  .btn-clear {
    color: white;
  }
}
</style>
